module.exports = __webpack_public_path__ + "static/media/news-banner.abbb15af.jpg";